// src/directives/track/index.js
import type { App, Directive } from 'vue'
import type { TrackValue } from './interface'
import Click from './click'
import Exposure from './exposure'

// 实例化曝光和点击
const cli = new Click()
const exp = new Exposure()

const trackDirective: Directive<HTMLElement, TrackValue> = {
  created(el, binding) {
    const { arg = 'click', value } = binding

    if (arg === 'click')
      cli.add({ el, value })

    if (arg === 'exposure')
      exp.add({ el, value })
  },
}

export default function (app: App) {
  app.directive('track', trackDirective)
}
